export default "__VITE_PUBLIC_ASSET__3c34f721__"